import { render, staticRenderFns } from "./job_fair_oldPosition.vue?vue&type=template&id=0a0c3e0d&scoped=true"
import script from "./job_fair_oldPosition.vue?vue&type=script&lang=js"
export * from "./job_fair_oldPosition.vue?vue&type=script&lang=js"
import style0 from "./job_fair_oldPosition.vue?vue&type=style&index=0&id=0a0c3e0d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0c3e0d",
  null
  
)

export default component.exports